import { render, staticRenderFns } from "./DashboardProfitMedal.vue?vue&type=template&id=51cfda9c&"
import script from "./DashboardProfitMedal.vue?vue&type=script&lang=js&"
export * from "./DashboardProfitMedal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports